import { useQuery } from '@tanstack/react-query'

import { trpc, trpcClient } from '@maxus/website/lib'

type AuthStatus = 'loading' | 'authed' | 'guest'

export type AuthUser = Awaited<ReturnType<typeof trpcClient.auth.me.query>>

export const authQueryOptions = trpc.auth.me.queryOptions(undefined, {
  retry: false,
  staleTime: Infinity,
})

export const useAuth = (): { status: AuthStatus; user: AuthUser | null } => {
  const q = useQuery(authQueryOptions)
  const status: AuthStatus = q.isPending ? 'loading' : q.isError ? 'guest' : 'authed'

  return { status, user: q.data ?? null }
}
